import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Input } from './ui/input';
import { Button } from './ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

const DemoBanner = () => (
  <>
    <div className="fixed inset-x-0 top-0 z-[60] bg-red-600 py-1 text-center text-xs font-bold tracking-widest text-white shadow" data-testid="demo-only-banner">
      DEMO ONLY - not for design, bidding or construction
    </div>
    <div className="pointer-events-none fixed inset-0 z-[55] flex items-center justify-center overflow-hidden" aria-hidden="true">
      <span className="-rotate-[30deg] select-none whitespace-nowrap text-[14vw] font-black text-red-600/[0.06]" data-testid="demo-only-watermark">DEMO ONLY</span>
    </div>
    <div className="h-6" />
  </>
);

const ChangePassword = ({ onDone }) => {
  const [cur, setCur] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (pw !== pw2) { setErr('The new passwords do not match'); return; }
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/auth/change-password`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('session_token') || ''}` },
        body: JSON.stringify({ current_password: cur, new_password: pw }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setErr(typeof d.detail === 'string' ? d.detail : 'Could not change the password'); return; }
      onDone();
    } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[900] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" role="dialog" aria-modal="true" data-testid="change-password-dialog">
        <h2 className="text-lg font-semibold">Choose your own password</h2>
        <p className="mb-4 text-sm text-gray-600">Welcome to PoleGenius. Please replace the temporary password before you continue.</p>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" placeholder="Temporary password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="change-password-current" />
          <Input type="password" placeholder="New password (8+ characters)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="change-password-new" />
          <Input type="password" placeholder="Repeat new password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="change-password-confirm" />
          {err && <p className="text-sm text-red-600" data-testid="change-password-error">{err}</p>}
          <Button type="submit" disabled={busy || !cur || pw.length < 8} className="w-full" data-testid="change-password-submit">{busy ? 'Saving...' : 'Save new password'}</Button>
        </form>
      </div>
    </div>
  );
};

export const DemoAccountGate = () => {
  const { user, isAuthenticated, checkAuthStatus } = useAuth();
  if (!isAuthenticated || !user) return null;
  return (
    <>
      {user.demo_only && <DemoBanner />}
      {user.must_change_password && <ChangePassword onDone={() => checkAuthStatus()} />}
    </>
  );
};
